import React from "react";

import { formatDate } from "@/utils";

import styles from "./NewsItem.module.scss"
import { INewsItemProps } from "./types";
import greenArrow from "@/assets/icons/greenArrow.svg";
import { useNavigate } from "react-router-dom";

export const NewsItem: React.FC<INewsItemProps> = ({ item }) => {
	const navigate = useNavigate();

	const handleNewsClick = (item: any) => {
		navigate("more", { state: { item }});
	};

	return(
		<div className={styles.newsItem} onClick={() => handleNewsClick(item)}>
			<div className={styles.dateTitle}>
				{formatDate(item.created_at)}
			</div>
			<div className={styles.title}>
				<span >
					{item.title}
				</span>
				<img src={greenArrow} alt="green arrow" />
			</div>
			<div className={styles.content}>
				{item.text && item.text.substring(0, 100)}
				{item.text && item.text.length > 100 && "..."}
			</div>
		</div>
	)
}